// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-button {
  font-size: var(--font-medium);
  font-weight: 600;
}
.vert-button.w-full {
  width: 100%;
}
.vert-button:not([disabled]).ant-btn-highlight {
  background-color: var(--color-detached) !important;
}
.vert-button:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
  border-color: var(--color-highlight-darker) !important;
}
.vert-button:not([disabled]).ant-btn-default {
  border-color: var(--color-detached) !important;
  color: var(--color-detached) !important;
  transition: all 0.2s ease-in-out;
}
.vert-button:not([disabled]).ant-btn-default:hover {
  background-color: transparent !important;
  color: var(--color-highlight-darker) !important;
  border-color: var(--color-border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/common/button.less"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,gBAAA;AACJ;AAAI;EACI,WAAA;AAER;AACQ;EACI,kDAAA;AACZ;AAAY;EACI,0DAAA;EACA,sDAAA;AAEhB;AAEQ;EACI,8CAAA;EACA,uCAAA;EACA,gCAAA;AAAZ;AAEY;EACI,wCAAA;EACA,+CAAA;EACA,4CAAA;AAAhB","sourcesContent":[".vert-button {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    &.w-full {\n        width: 100%;\n    }\n    &:not([disabled]) {\n        &.ant-btn-highlight {\n            background-color: var(--color-detached) !important;\n            &:hover {\n                background-color:  var(--color-highlight-darker) !important;\n                border-color: var(--color-highlight-darker) !important;\n            }\n        }\n\n        &.ant-btn-default {\n            border-color: var(--color-detached) !important;\n            color: var(--color-detached) !important;\n            transition: all 0.2s ease-in-out;\n\n            &:hover {\n                background-color: transparent !important;\n                color: var(--color-highlight-darker) !important;\n                border-color: var(--color-border) !important;\n            }\n        }\n    }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
